import { axios } from '@boot/axios.js';

/**
 * Load the  asset detail from the backend API
 * @param {string} assetUUID - Asset UUID.
 * @return {Object} - Asset.
 */
async function loadAssetByUUID(assetUUID) {
    let asset = null;
    try {
        const response = await axios.get(`/assets/?uuid=${assetUUID}`);
        if (response.status === 200) {
            if (response.data.results) {
                asset = response.data.results[0];
            }
        } else {
            console.error('Failed to fetch asset due to: ');
        }
    } catch (error) {
        console.error('Failed to fetch asset due to: ', error);
    }
    return asset;
}

export { loadAssetByUUID };
